import { Typography } from "@material-ui/core";
import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { useHistory } from "../../shared/hooks/useHistory";
import { assetsUrl } from "../../common/config";
import { LearningPathApi } from "../../models/api/learning-path";
import { setCurrentLearningPathId } from "../../services";
import { QuickwinTrophyIcon } from "../../shared/icons/gamePlan";
import { setActiveLearningPath } from "../../shared/slices/activeLearningPath";
import { useStyles } from "../learning-path-cards/learning-path-cards.styles";

// TODO: This component is not enabled yet, but after queries optimization,
// this might not work as expected, before enable it again, please check if it's
// working properly

interface Props {
  image: number;
  learningPath: LearningPathApi;
}

export const LearningPathCard = ({ image, learningPath }: Props) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  const { mutate } = useMutation(setCurrentLearningPathId, {
    onSuccess: (_, { learningPathId }) => {
      dispatch(setActiveLearningPath(learningPathId));
      history.push("/learningPath");
    },
  });

  const getImageUrl = () =>
    `${assetsUrl}/learning/learning-path-overlay-${((image - 1) % 3) + 1}.svg`;

  const setLearningPath = () => {
    mutate({ learningPathId: learningPath.focusId });
  };

  return (
    <div className={classes.card} onClick={setLearningPath}>
      <div className={classes.square}>
        <Typography className={classes.text}>{learningPath.name}</Typography>
        <span className={classes.quickWins}>
          <QuickwinTrophyIcon fillColor="white" showBackground={false} />
          <span className={classes.quickWinsText}>3 Quick Wins</span>
        </span>
        <img src={getImageUrl()} className={classes.overlay} />
      </div>
    </div>
  );
};
